<template>
  <div
      class="drop-wrapper"
      :class="{'active': dragActive}"
      @dragenter.prevent="setActive"
      @dragover.prevent="setActive"
      @dragleave.prevent="setInactive"
      @drop.prevent="onDrop"
      @click="selectFile"
  >
    <input type="file" :id="fileInputId" style="display: none" @change="onFileInputChange" accept="image/*">
    <img v-if="file === null" class="upload-image-placeholder" src="../assets/images/upload-image.svg" />
    <img v-else class="preview-image" :src="imagePreview" :alt="$t('file_preview')" />
  </div>
</template>

<script>
import fileService from "@/service/fileService";

export default {
  name: 'IconDrop',
  data() {
    return {
      chunkUploadRunning:false,
      dragActive: false,
      file: null,
      imagePreview: null,
      fileInputId: null,
    }
  },
  props: {
    notBinary:{
      type: Boolean,
      default: false
    },
    selectedFile: {
      type: String,
      default: ''
    },
    onFileSelected: {
      type: Function,
      required: true
    },
  },
  watch: {
    attach(val) {
      this.checkAttach(val);
    },
    selectedFile: {
      handler: function (val, oldVal) {
        this.checkSelectedFile(val);
      },
      deep: true
    },
    chunkUploadRunning(val) {
      const existingIndex = this.uploadStatus.findIndex(item => item.hasOwnProperty(this.fileInputId));
      if (existingIndex !== -1) {
        this.uploadStatus[existingIndex][this.fileInputId] = val;
      } else {
        this.uploadStatus.push({ [this.fileInputId]: val });
      }
    }
  },
  methods: {
    setActive() {
      this.dragActive = true;
    },
    setInactive() {
      this.dragActive = false;
    },
    onDrop(e) {
      this.setInactive();
      const files = e.dataTransfer.files;
      this.handleFileSelection(files);
    },
    onFileInputChange(e) {
      const files = e.target.files;
      this.handleFileSelection(files);
    },
    selectFile() {
      document.getElementById(this.fileInputId).click();
    },
    async handleFileSelection(files) {
      if (files.length > 0) {
        this.file = files[0];

        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(files[0]);

        if(!this.notBinary){
        this.onFileSelected(files[0]);
        }
        else if(this.notBinary) {
          const file = files[0];
          const originalFileName = file.name;
          const originalFileSize = file.size;

          const chunkSize = 1024 * 1024; // 1MB chunk size
          const chunks = Math.ceil(file.size / chunkSize);

          this.chunkUploadRunning = true;

          try {
            for (let i = 0; i < chunks; i++) {
              const chunk = file.slice(i * chunkSize, Math.min((i + 1) * chunkSize, file.size));
              const formData = new FormData();
              formData.append('file', chunk, file.name);
              formData.append('chunk', i);
              formData.append('chunks', chunks);
              formData.append('name', file.name);

              const response = await fileService.uploadFile(formData);
              this.onFileSelected(response.data.data.uuid);
              this.progress = Math.round(((i + 1) / chunks) * 100);
            }

            this.file = {
              name: originalFileName,
              size: originalFileSize
            };
          } catch (error) {
            this.$snackbar.add({
              text: this.$t('upload_service_error'),
              type: 'error'
            });
            this.onFileSelected(null);
            this.file = null;
            this.imagePreview = null;
          } finally {
            this.chunkUploadRunning = false;
          }
        }
      }
    },
    checkSelectedFile(selectedFile) {
      try {
        console.log("selectedFile", selectedFile)

        if (selectedFile && selectedFile !== '' && selectedFile.startsWith('http')) {
          this.file = {
            name: selectedFile.split('/').slice(-1)[0],
            size: "-",
          }

          this.imagePreview = selectedFile;

        }
      } catch (e) {}
    },
  },
  created() {
    this.fileInputId = this.randomFileInputId;
    this.checkSelectedFile(this.selectedFile);
  },
  computed: {
    randomFileInputId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
  }
}
</script>

<style scoped>
.drop-wrapper {
  border: 1px solid #F5F5F5;
  border-radius: 8px;
  padding: 15px 15px;
  width: 52px;
  font-family: 'euclid_regular', sans-serif;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-image, .upload-image-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.active {
  border: 1px solid #4A68F8;
  background: #EBEDFB;
}
</style>
